/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_AddInputs */



/**
* | output |
* | --- |
* | "Switch off for…" |
*
* @param {Meetings_Exception_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_add = /** @type {((inputs?: Meetings_Exception_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zet uit voor…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactiver pour…")
	return /** @type {LocalizedString} */ ("Switch off for…")
});